import { i18n } from '../../i18n/translate';
import type { MenuEnvironment, MenuItem } from './types';

export const everfiNextAdminLeft = (environment: MenuEnvironment): MenuItem => {
  const { MENU_DOMAIN_FOR_NEXT } = environment;

  const contentUrl = `${MENU_DOMAIN_FOR_NEXT}/admin/content?exclude=page&exclude=header&exclude=layout`;
  const layoutUrl = `${MENU_DOMAIN_FOR_NEXT}/admin/content?hide_filter=true&type=layout`;

  return {
    id: 'foundry--universal_navigation--menus--everfi_next_admin_left',
    type: 'menus',
    slug: 'foundry--universal_navigation--menus--everfi_next_admin_left',
    title: '',
    icon: '',
    font_family: '',
    css_class: '',
    target_url: '',
    target_method: '',
    new_window: false,
    subsection: false,
    submenu_items: [
      {
        id: '',
        module: 'next',
        slug: '',
        title: i18n.t('Accounts'),
        icon: 'briefcase',
        font_family: '',
        css_class: '',
        permissions: [{ admin_has_permission: ['manage_next'] }],
        target_url: `${MENU_DOMAIN_FOR_NEXT}/admin/accounts`,
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100,
      },
      {
        id: '',
        module: 'next',
        slug: '',
        title: i18n.t('Content'),
        icon: 'book-reader',
        font_family: '',
        css_class: '',
        permissions: [{ admin_has_permission: ['manage_next'] }],
        target_url: '',
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [
          {
            id: '',
            module: 'next',
            slug: '',
            title: i18n.t('List Content'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['manage_next'] }],
            target_url: contentUrl,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            module: 'next',
            slug: '',
            title: i18n.t('List Playlists'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['next_product_management'] }],
            target_url: `${MENU_DOMAIN_FOR_NEXT}/admin/playlists`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            module: 'next',
            slug: '',
            title: i18n.t('List Diagnostics'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['next_product_management'] }],
            target_url: `${MENU_DOMAIN_FOR_NEXT}/admin/diagnostics`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            module: 'next',
            slug: '',
            title: i18n.t('List Layouts'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['next_manage_layouts'] }],
            target_url: layoutUrl,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            module: 'next',
            slug: '',
            title: i18n.t('Action Plans'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['next_product_management'] }],
            target_url: `${MENU_DOMAIN_FOR_NEXT}/admin/action_plans`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            module: 'next',
            slug: '',
            title: i18n.t('Global Translations'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['next_product_management'] }],
            target_url: `${MENU_DOMAIN_FOR_NEXT}/admin/localizations`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            module: 'next',
            slug: '',
            title: i18n.t('Badges'),
            icon: '',
            font_family: '',
            css_class: '',
            permissions: [{ admin_has_permission: ['manage_content'] }],
            target_url: `${MENU_DOMAIN_FOR_NEXT}/admin/award_rules`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
        ],
        weight: 100,
      },
    ],
  };
};
